import { DebugLog } from './core/DebugLog';
import { DEBUG_LOG_FILE_PATH } from './core/FileDebugLog';
import { markAppExit, markAppStart } from './core/RuntimeMonitor';
import { SaveStore } from './core/SaveStore';
import { createGame } from './game';

markAppStart();
DebugLog.info('Runtime', 'app start', { debugLogFilePath: DEBUG_LOG_FILE_PATH });

window.addEventListener('error', (event) => {
  DebugLog.error('window.onerror', event.message, {
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
  });
});

window.addEventListener('unhandledrejection', (event) => {
  DebugLog.error('window.unhandledrejection', 'Unhandled promise rejection', event.reason);
});

window.addEventListener('beforeunload', () => {
  DebugLog.info('Runtime', 'beforeunload');
  SaveStore.flushSession();
  markAppExit();
});

createGame('app');
